import React from "react";
import { useLocation, Link as RouterLink } from "react-router-dom";
//
import {
    Link,
    ListItem,
    ListItemIcon,
    ListItemText,
} from "@material-ui/core";

export default function MenuLink(props) {
    const { to, handler, icon, name, disabled } = props;
    const location = useLocation();

    return (
        <Link
            component={RouterLink}
            to={to}
            underline="none"
            className={location.pathname === to ? "active" : undefined}
            onClick={handler || (() => {})}
        >
            <ListItem button disabled={disabled}>
                <ListItemIcon>{icon}</ListItemIcon>
                <ListItemText primary={name} />
            </ListItem>
        </Link>
    );
}
